function updateSignature() {
  let signatureBloc1 = '';
  let signatureBloc2 = '';

  $('#image').html('<img src="' + $('#input-themes option:selected').data('file') + '" width="52" height="155">');

  if ($('#input-names').val() !== '') {
    signatureBloc1 = '<strong>' + $('#input-names').val() + '</strong>';
  }

  if ($('#input-title').val() !== '') {
    signatureBloc1 += '<br>' + $('#input-title').val()
  }

  signatureBloc1 += '<br>&nbsp;';

  if ($('#input-phone').val() !== '') {
    signatureBloc1 += '<br>' + $('#input-phone').val();
  }

  if ($('#input-email').val() !== '') {
    signatureBloc1 += '<br>' + $('#input-email').val();
  }

  if ($('#input-absences').val() !== '') {
    signatureBloc1 += '<br><strong style="color:' + $('#input-themes option:selected').data('color') + ';">' + $('#input-absences').val() + '</strong>';
  }

  $('.signature #bloc-1').html(signatureBloc1);

  let color = $('#input-themes option:selected').data('color');
  //if (color === '#d9cf45') color = '#646464';

  $('.colored').css('color', color);
}

export function ComponentSignatures() {
  if ($('body').hasClass('page-template-signature')) {

    if ($('#pwbox-5513').length > 0) $('#pwbox-5513').get(0).focus();
    if ($('#input-names').length > 0) $('#input-names').get(0).focus();

    $('#input-names, #input-title, #input-phone, #input-email, #input-absences').on('keyup', (event) => {
      updateSignature();
    });

    $('#input-themes').on('change', (event) => {
      updateSignature();
    });

    $('#btn-copy-signature').on('click', (event) => {
      event.preventDefault();

      const html = $('.signature').html();

      try {
        const clipboardItem = new ClipboardItem({
          'text/html': new Blob([html], { type: 'text/html' }),
          'text/plain': new Blob([html], { type: 'text/plain' })
        });

        navigator.clipboard.write([clipboardItem]).then(() => {
          alert('Signature copiée avec succès !');
        }, (err) => {
          alert('Une erreur est survenue lors de la copie de la signature.\nVeuillez copier le bloc ci-dessus manuellement.');
        });
      } catch (err) {
        alert('Le copie automatique de la signature fonctionne uniquement avec les dernières versions de Chrome ou Safari.');
      }
    });

    updateSignature();
  }
}
